export const EvaluationSkill = {
    path: '/evaluation_skills',
    name: 'evaluation_skills',
    component: () => import('@/views/Evaluation/Skill/EvaluationSkillPage.vue'),
    children: [
        {
            path: '/evaluation_skills/add',
            name: 'evaluation_skills.add',
            component: () => import('@/views/Evaluation/Skill/Form/EvaluationSkillForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/evaluation_skills/edit/:id',
            name: 'evaluation_skills.edit',
            component: () => import('@/views/Evaluation/Skill/Form/EvaluationSkillForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/evaluation_skills/launch/:id',
            name: 'evaluation_skills.launch',
            component: () => import('@/views/Evaluation/Skill/Form/EvaluationSkillLaunchForm.vue'),
        },
        {
            path: '/evaluation_skills/delete/:id',
            name: 'evaluation_skills.delete',
            component: () => import('@/views/Evaluation/Skill/Form/EvaluationSkillForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/evaluation_skills/view/:id',
            name: 'evaluation_skills.view',
            component: () => import('@/views/Evaluation/Skill/Form/EvaluationSkillForm.vue'),
            props: {viewAction: true}
        },
        {
            path: '/evaluation_skills/documents/:id',
            name: 'evaluation_skills.documents',
            component: () => import('@/views/Edms/Document/ModuleDocumentPage.vue'),
            props: {module: "EVALUATION_SKILL"}
        },
        {
            path: '/evaluation_skills/template_applications/:id',
            name: 'evaluation_skills.template_applications',
            component: () => import('@/views/Edms/TemplateApplication/ModuleTemplateApplicationPage.vue'),
            props: {module: "EVALUATION_SKILL"}
        },
    ]
}

export const EvaluationSkillCandidate = {
    path: '/evaluation_skill_candidates',
    name: 'evaluation_skill_candidates',
    component: () => import('@/views/Evaluation/Skill/EvaluationSkillCandidatePage.vue'),
    children: [
        {
            path: '/evaluation_skill_candidates/interviews/edit/:id',
            name: 'evaluation_skill_candidates.interviews.edit',
            component: () => import('@/views/Evaluation/EvaluationInterview/Form/EvaluationSkillInterviewForm.vue'),
            props: {updateAction: true, getIt: true}
        },
        {
            path: '/evaluation_skill_candidates/interviews/view/:id',
            name: 'evaluation_skill_candidates.interviews.view',
            component: () => import('@/views/Evaluation/EvaluationInterview/Form/EvaluationSkillInterviewForm.vue'),
            props: {viewAction: true, getIt: true},
        },
        {
            path: '/evaluation_skill_candidates/tolerate/:id',
            name: 'evaluation_skill_candidates.tolerate',
            component: () => import('@/views/Evaluation/Skill/Form/EvaluationSkillTolerateForm.vue'),
        },
    ]
}